(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["two-link-cards"] && !Shopify.designMode) return;
  try {
    
  // Two Link Cards - IntersectionObserver animation (scoped)
  // Shopifyテーマのパフォーマンスベストプラクティスに従い、JSは装飾用途のみに限定（progressive enhancement）:contentReference[oaicite:4]{index=4}
  (() => {
    const root = document.getElementById('two-link-cards-{{ section.id }}');
    if (!root) return;

    const enabled = root.dataset.animEnabled === 'true';
    const cards = root.querySelectorAll('[data-anim="fade-up"]');

    // If disabled or not supported
    if (!enabled || !('IntersectionObserver' in window)) {
      cards.forEach(el => el.setAttribute('data-io', 'off'));
      return;
    }

    cards.forEach(el => el.setAttribute('data-io', 'init'));

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-io', 'in');
          io.unobserve(entry.target);
        }
      }
    }, {
      root: null,
      threshold: 0.15
    });

    cards.forEach(el => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();
})();
